import { Form, Space } from 'antd';

import { PREFIX } from '@app/constants';
import { ClientReminderComponent } from '@app/pages/Notifications/components';
import { NotificationsButtons } from '@app/pages/Notifications/components/NotificationsButtons.main';
import { RecordsPriorityIntegration } from '@app/pages/Notifications/components/RecordsPriorityIntegration';
import {
  useSettingUpAutomaticMessagingToClients,
  useSettingUpAutomaticMessagingToClientsEffects,
} from '@app/pages/Notifications/hooks';

import '@app/pages/Notifications/styles/SettingUpAutomaticMessagingToClients.desktop.scss';

export const SettingUpAutomaticMessagingToClients: React.FC = () => {
  const { data, isDataLoading } =
    useSettingUpAutomaticMessagingToClientsEffects();
  const {
    form,
    handleSave,
    isSetClientRemindersLoading,
    beforeBirthdayReminder,
    afterBirthdayReminder,
    defaultIntegrations,
    setDefaultIntegrations,
    sendToAll,
    setSendToAll,
    sendByLastActiveIntegration,
    setSendByLastActiveIntegration,
  } = useSettingUpAutomaticMessagingToClients({
    data,
  });

  return (
    <div className={`${PREFIX}setting-up-automatic-messaging-to-clients`}>
      <Form
        form={form}
        initialValues={{
          beforeBirthdayMinutes: 0,
          beforeBirthdayHours: 0,
          beforeBirthdayDays: 0,
          afterBirthdayMinutes: 0,
          afterBirthdayHours: 0,
          afterBirthdayDays: 0,
        }}
        onFinish={handleSave}
      >
        <Space direction="vertical" size={36}>
          <RecordsPriorityIntegration
            defaultIntegrations={defaultIntegrations}
            setDefaultIntegrations={setDefaultIntegrations}
            data={data}
            sendToAll={sendToAll}
            setSendToAll={setSendToAll}
            sendByLastActiveIntegration={sendByLastActiveIntegration}
            setSendByLastActiveIntegration={setSendByLastActiveIntegration}
          />

          <ClientReminderComponent
            form={form}
            title="Сообщение клиенту до дня рождения"
            description="Настройте сообщение, отправляемое клиенту в WhatsApp до дня рождения"
            type="before"
            reminder={beforeBirthdayReminder}
          />

          <ClientReminderComponent
            form={form}
            title="Сообщение клиенту после дня рождения"
            description="Настройте сообщение, отправляемое клиенту в WhatsApp после дня рождения"
            type="after"
            reminder={afterBirthdayReminder}
          />

          <NotificationsButtons
            onSave={form.submit}
            isSaveDisabled={isDataLoading || isSetClientRemindersLoading}
          />
        </Space>
      </Form>
    </div>
  );
};
